/* Edits and optional preview email share the existing portrait state and cart path. */
(() => {
  function start() {
  const root = document.querySelector('[data-uk-portrait]');
  const composer = root?.querySelector('.gemini-transformer');
  const presentation = root?.ukPortraitPresentation;
  const engine = composer?.ukPortraitEngine;
  if (!root || !presentation || !engine) return false;
  if (root.dataset.actionsInitialized) return true;
  root.dataset.actionsInitialized = 'true';
  const $ = selector => root.querySelector(selector);
  const editPanel = $('[data-uk-edit-panel]'), emailPanel = $('[data-uk-email-panel]');
  const saveLater = emailPanel?.closest('.uk-portrait__save-later');
  const editForm = $('[data-uk-edit-form]'), emailForm = $('[data-uk-email-form]');
  const editButton = $('[data-uk-edit-submit]'), emailButton = $('[data-uk-email-submit]');
  const note = $('[data-uk-edit-note]'), email = $('[data-uk-email-input]');
  const order = $('[data-uk-order]');
  let editing = false, emailing = false, revision = 0;
  let generating = false, generation = 0, generationArtwork = '', queuedEmail = null, offerDismissed = false;
  let emailedGateArtwork = '';
  let armedEmailVisit = null, emailVisitRecorded = false;
  async function recordEmailVisit(marker, previewToken) {
    let timer;
    try {
      const controller = new AbortController();
      timer = setTimeout(() => controller.abort(), 5000);
      await fetch('/apps/image-composer/email-preview/visit', {
        method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin',
        keepalive:true, signal:controller.signal, body:JSON.stringify({marker, previewToken})
      });
    } catch { /* Analytics must never affect the saved portrait or basket. */ }
    finally { clearTimeout(timer); }
  }
  function clearEmailVisit() {
    const armed = armedEmailVisit;
    armedEmailVisit = null;
    if (!armed) return;
    document.removeEventListener('pointerdown', armed.interact, true);
    document.removeEventListener('keydown', armed.interact, true);
  }
  function armEmailVisit(previewToken, artworkUrl) {
    try {
      const params = new URLSearchParams(location.search), marker = params.get('bl_email_visit');
      const current = presentation.state();
      if (emailVisitRecorded || !marker || marker.length > 4096 || params.get('uk_preview') !== previewToken ||
          !current.ready || current.demo || current.portrait !== artworkUrl) return;
      clearEmailVisit();
      const interact = event => {
        try {
          if (!event.isTrusted || document.visibilityState !== 'visible') return;
          const state = presentation.state(), currentParams = new URLSearchParams(location.search);
          if (!state.ready || state.demo || state.portrait !== artworkUrl || currentParams.get('uk_preview') !== previewToken ||
              currentParams.get('bl_email_visit') !== marker) { clearEmailVisit(); return; }
          clearEmailVisit(); emailVisitRecorded = true;
          void recordEmailVisit(marker, previewToken);
        } catch { clearEmailVisit(); }
      };
      armedEmailVisit = {artworkUrl, interact};
      document.addEventListener('pointerdown', interact, {capture:true, passive:true});
      document.addEventListener('keydown', interact, {capture:true, passive:true});
    } catch { clearEmailVisit(); }
  }
  const validArtwork = url => /^https:\/\/cdn\.shopify\.com\/s\/files\/1\/0284\/5284\/7688\/files\/gemini_[^?#]+(?:\?[^#]*)?$/.test(String(url || ''));
  const status = (element, text, error = false) => { element.textContent = text; element.dataset.error = String(error); };
  function sync() {
    const state = presentation.state();
    const ready = !state.demo && validArtwork(state.portrait) && state.ready;
    const hasPortrait = !state.demo && validArtwork(state.portrait) && root.dataset.view === 'ready';
    if (armedEmailVisit && (!hasPortrait || state.portrait !== armedEmailVisit.artworkUrl)) clearEmailVisit();
    const alreadyEmailed = hasPortrait && state.portrait === emailedGateArtwork;
    editPanel.hidden = !hasPortrait;
    if (saveLater) saveLater.hidden = alreadyEmailed;
    emailPanel.hidden = (!hasPortrait && !generating) || alreadyEmailed || offerDismissed || root.dataset.ukEmailEnabled === 'false';
    editButton.disabled = editing || emailing || !ready;
    emailButton.disabled = editing || emailing || Boolean(queuedEmail) || (!ready && !generating);
  }
  const observer = new MutationObserver(sync);
  observer.observe(root, {attributes:true, attributeFilter:['data-view','data-settled','data-variant-id','data-uk-busy']});
  root.addEventListener('uk:portrait-presented', sync);
  const api = async (path, payload) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 25000);
    try {
      const response = await fetch('/apps/image-composer/portrait-preview/' + path, {
        method:payload ? 'POST' : 'GET', headers:payload ? {'Content-Type':'application/json','Accept':'application/json'} : {'Accept':'application/json'},
        ...(payload ? {body:JSON.stringify(payload)} : {}), signal:controller.signal
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) throw new Error(data.error || 'This is temporarily unavailable. Please try again later.');
      return data;
    } finally { clearTimeout(timer); }
  };
  function updateSavedUrl(entry) {
    const url = new URL(location.href);
    url.searchParams.delete('uk_preview');
    url.searchParams.set('uk_saved', String(entry.id));
    url.searchParams.set('uk_saved_url', entry.hostedUrl);
    url.searchParams.set('variant', presentation.state().variantId);
    history.replaceState(history.state, '', url);
  }
  async function commitArtwork(result, source) {
    let timer, done;
    const presented = new Promise((resolve, reject) => {
      timer = setTimeout(() => { root.removeEventListener('uk:portrait-presented', done); reject(new Error('The preview is taking longer to display. Please reopen it from Saved portraits.')); }, 60000);
      done = () => { clearTimeout(timer); root.removeEventListener('uk:portrait-presented', done); resolve(); };
      root.addEventListener('uk:portrait-presented', done);
    });
    // Attach a rejection handler immediately even if image loading fails first.
    presented.catch(() => {});
    try {
      const entry = await engine.applyArtwork(result, source);
      await presented;
      if (!presentation.state().ready) throw new Error('Your portrait is saved but its preview could not display. Please reopen it from Saved portraits.');
      return entry;
    } finally { clearTimeout(timer); root.removeEventListener('uk:portrait-presented', done); }
  }
  async function currentImagePayload(url) {
    const response = await fetch(url, {signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Unable to load this portrait. Please try again.');
    const blob = await response.blob();
    if (!/^image\//.test(blob.type) || blob.size > 15 * 1024 * 1024) throw new Error('This portrait could not be loaded for editing.');
    const data = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(String(reader.result)); reader.onerror = reject; reader.readAsDataURL(blob); });
    return {base64Image:data.slice(data.indexOf(',') + 1),mimeType:blob.type};
  }
  function applyEmailFinish(savedVariantId) {
    const requested = new URLSearchParams(location.search).get('uk_finish');
    if (!['canvas','framed'].includes(requested)) return;
    let changed = false;
    try {
      const product = JSON.parse(root.querySelector('[data-uk-product]').textContent);
      const variants = product.variants.filter(v => Array.isArray(v.options) && v.options.length >= 2);
      const saved = variants.find(v => String(v.id) === String(savedVariantId));
      if (!saved || String(product.id) !== root.dataset.productId) return;
      // Use the same option meanings as uk-portrait-preview.js. IDs come only
      // from this product's actual Shopify variants, never a guessed mapping.
      const isCanvas = v => /^canvas/i.test(v.options[0]);
      const finishOf = v => isCanvas(v) ? 'canvas' : /black/i.test(v.options[1]) ? 'black' : /white/i.test(v.options[1]) ? 'white' : /natural|wood/i.test(v.options[1]) && !/no frame/i.test(v.options[1]) ? 'natural' : 'none';
      const sizeOf = v => isCanvas(v) && /30\s*[x×]\s*40\s*cm/i.test(v.options[0]) ? '30X40' : (v.options[0].match(/A[234]/i) || [v.options[0]])[0].toUpperCase();
      const frames = ['black','white','natural'], savedFinish = finishOf(saved), savedSize = sizeOf(saved);
      const preferredFrames = frames.includes(savedFinish) ? [savedFinish, ...frames.filter(key => key !== savedFinish)] : frames;
      const available = variants.filter(v => v.available &&
        (requested === 'canvas' ? finishOf(v) === 'canvas' : frames.includes(finishOf(v))));
      const sameSize = available.filter(v => sizeOf(v) === savedSize);
      const matching = sameSize.length ? sameSize : available;
      // Preserve any further Shopify options before choosing the site's default
      // black/white/natural frame order. As with the site's finish switch, fall
      // back to an available size when this finish has no saved-size option.
      const optionChanges = v => saved.options.slice(2).reduce((count, value, index) => count + (v.options[index + 2] === value ? 0 : 1), 0);
      matching.sort((a, b) => optionChanges(a) - optionChanges(b) ||
        (requested === 'framed' ? preferredFrames.indexOf(finishOf(a)) - preferredFrames.indexOf(finishOf(b)) : 0));
      const target = matching.find(v => String(v.id) === String(saved.id)) || matching[0];
      if (!target) return;
      changed = true;
      if (!presentation.selectVariant(target.id, true)) {
        presentation.selectVariant(savedVariantId, true);
        return;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', String(target.id));
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch {
      // A missing/unavailable override must never prevent the saved artwork opening.
      if (changed) { try { presentation.selectVariant(savedVariantId, true); } catch {} }
    }
  }
  editForm.addEventListener('submit', async event => {
    event.preventDefault();
    const state = presentation.state(), change = note.value.trim();
    if (editing || emailing || !state.ready || state.demo || !validArtwork(state.portrait)) return;
    if (!change) { status($('[data-uk-edit-status]'), 'Please describe the change you would like.', true); note.focus(); return; }
    editing = true; const operation = ++revision;
    presentation.busy(true); sync();
    note.disabled = true;
    editButton.textContent = 'Updating your portrait…';
    status($('[data-uk-edit-status]'), 'Updating your portrait. Keep this page open while we apply your change.');
    const selection = $('.uk-portrait__selection-panel'); selection.inert = true;
    try {
      const image = await currentImagePayload(state.portrait);
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 120000);
      let response, data;
      try {
        response = await fetch(engine.endpoint, {method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({
          ...image, prompt:'Edit the supplied finished pet portrait. Preserve the exact pet identity, markings, pose, artistic style, composition and image aspect ratio except for the specific change requested. Do not add text, frames, borders or mockups. Apply only this customer change: ' + change,
          referenceImageUrl:state.portrait, fileName:'portrait-edit',originalName:'portrait-edit'
        })});
        data = await response.json().catch(() => ({}));
      } finally { clearTimeout(timer); }
      if (!response.ok || !validArtwork(data.url)) throw new Error(data.error || 'We could not save the updated portrait. Your previous portrait is still available.');
      if (operation !== revision) return;
      const entry = await commitArtwork({url:data.url,id:'edit-' + Date.now()}, 'amended');
      updateSavedUrl(entry);
      note.value = '';
      status($('[data-uk-edit-status]'), 'Your portrait has been updated. Review the image above before ordering.');
      status($('[data-uk-email-status]'), '');
    } catch (error) {
      status($('[data-uk-edit-status]'), error.name === 'AbortError'
        ? 'We could not confirm the edit finished. Your previous portrait is still saved. Please wait before trying again.'
        : error.message || 'Your portrait could not be updated. Your previous portrait is still saved.', true);
    } finally {
      editing = false; note.disabled = false; selection.inert = false;
      presentation.busy(false); editButton.textContent = 'Update my portrait'; sync();
    }
  });
  async function sendPortraitEmail(recipient, state) {
    const operation = generation;
    emailing = true; sync(); emailButton.textContent = 'Sending…';
    status($('[data-uk-email-status]'), '');
    try {
      const result = await api('email', {email:recipient,productId:root.dataset.productId,variantId:state.variantId,artworkUrl:state.portrait,offer:'portrait-gate-10'});
      if (!['sent','already_sent'].includes(result.status) || result.discountCode !== 'YOURPORTRAIT10' || result.discountPercent !== 10) throw new Error('We could not confirm your email and discount. Please check your inbox before trying again.');
      if (operation !== generation) return;
      status($('[data-uk-email-status]'), 'Sent — use YOURPORTRAIT10 for 10% off. Your portrait link is in your inbox.');
    } catch (error) {
      if (operation !== generation) return;
      status($('[data-uk-email-status]'), error.name === 'AbortError' ? 'We could not confirm delivery. Please check your inbox before trying again.' : error.message, true);
    } finally { emailing = false; emailButton.textContent = generating ? 'Send' : 'Send my portrait + 10% off'; sync(); }
  }
  emailForm.addEventListener('submit', event => {
    event.preventDefault();
    if (root.dataset.ukEmailEnabled === 'false' || emailing || editing || !emailForm.reportValidity()) return;
    const state = presentation.state(), recipient = email.value.trim();
    if (state.ready && !state.demo && validArtwork(state.portrait)) {
      void sendPortraitEmail(recipient, state);
      root.ukPortraitOptionalOffer?.submitted();
      return;
    }
    if (!generating) return;
    queuedEmail = {recipient, generation};
    root.ukPortraitOptionalOffer?.submitted();
    emailButton.textContent = 'Queued';
    status($('[data-uk-email-status]'), 'Keep this page open — we’ll send it when your portrait is ready.');
    sync();
  });
  email.addEventListener('input', () => {
    if (!queuedEmail || queuedEmail.recipient === email.value.trim()) return;
    queuedEmail = null; emailButton.textContent = generating ? 'Send' : 'Send my portrait + 10% off';
    root.ukPortraitOptionalOffer?.submissionCancelled();
    status($('[data-uk-email-status]'), ''); sync();
  });
  // Keep generation progress visible without an email offer or email-entry hold.
  // The separate portrait-page email form stays in its original location.
  const progress = root.querySelector('.gemini-transformer__modal');
  if (progress && root.dataset.emailGateRequired !== 'true') {
    const loading = document.createElement('div');
    loading.className = 'uk-optional-loading'; loading.hidden = true;
    loading.innerHTML = `<div class="uk-optional-loading__sheet" role="dialog" aria-modal="true" aria-labelledby="uk-optional-heading">
      <button type="button" class="uk-optional-loading__close" aria-label="Close loading screen">×</button>
      <div class="uk-optional-loading__photo"><img alt="Your uploaded pet photo"><div class="uk-optional-loading__palette"></div><span class="uk-optional-loading__badge">Creating…</span><div class="uk-optional-loading__scrim"><p data-optional-stage role="status">Preparing your portrait…</p><div class="uk-optional-loading__meter"><span></span></div></div></div>
      <h2 id="uk-optional-heading" tabindex="-1">Creating your portrait…</h2><p class="uk-optional-loading__reassure">It will appear automatically when ready.</p>
      <div class="uk-optional-loading__proof"></div>
    </div>`;
    progress.appendChild(loading);
    const photo = loading.querySelector('img');
    const nativeNote = progress.querySelector('.gemini-transformer__modal-note'), nativeBar = progress.querySelector('.gemini-transformer__progress-bar');
    const file = composer.querySelector('input[type="file"]');
    let objectUrl = '', overlayOpen = false;
    function syncLoadingProgress() {
      if (!overlayOpen) return;
      if (presentation.state().ready) {
        loading.dataset.ready = 'true';
        loading.querySelector('h2').textContent = 'Your portrait is ready';
        loading.querySelector('.uk-optional-loading__badge').textContent = 'Ready';
        loading.querySelector('[data-optional-stage]').textContent = 'Your preview is ready';
        loading.querySelector('.uk-optional-loading__meter span').style.width = '100%';
        loading.querySelector('.uk-optional-loading__reassure').textContent = 'Opening your portrait…';
        return;
      }
      loading.querySelector('[data-optional-stage]').textContent = (nativeNote?.textContent || 'Preparing your portrait…')
        .replace('Creating artwork... this can take a moment.', 'Creating your portrait…')
        .replace('Blending colours and brushstrokes... hang tight!', 'Blending colours…')
        .replace('Almost there... lining up the perfect mockup for your order.', 'Preparing your preview…')
        .replace('Skipping background (not available)…', 'Preparing your preview…');
      loading.querySelector('.uk-optional-loading__meter span').style.width = nativeBar?.style.width || '0%';
    }
    if (nativeNote) new MutationObserver(syncLoadingProgress).observe(nativeNote, {childList:true,subtree:true,characterData:true});
    if (nativeBar) new MutationObserver(syncLoadingProgress).observe(nativeBar, {attributes:true,attributeFilter:['style']});
    root.addEventListener('uk:portrait-progress-open', () => {
      generation++; generating = true; generationArtwork = ''; queuedEmail = null; offerDismissed = false; overlayOpen = true;
      status($('[data-uk-email-status]'), ''); emailButton.textContent = 'Send';
      emailPanel.open = false;
      delete loading.dataset.ready;
      loading.querySelector('h2').textContent = 'Creating your portrait…';
      loading.querySelector('.uk-optional-loading__badge').textContent = 'Creating…';
      loading.querySelector('.uk-optional-loading__reassure').textContent = 'It will appear automatically when ready.';
      const rating = root.querySelector('.uk-portrait__rating');
      const proof = loading.querySelector('.uk-optional-loading__proof');
      proof.replaceChildren();
      if (rating) [...rating.children].forEach(child => proof.appendChild(child.cloneNode(true)));
      proof.hidden = !rating;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = file?.files?.[0] ? URL.createObjectURL(file.files[0]) : '';
      if (objectUrl) photo.src = objectUrl; else photo.removeAttribute('src');
      loading.hidden = false; progress.classList.add('uk-optional-loading-modal');
      sync(); syncLoadingProgress();
      loading.querySelector('h2').focus({preventScroll:true});
    });
    loading.querySelector('.uk-optional-loading__close').addEventListener('click', () => progress.querySelector('.gemini-transformer__modal-close')?.click());
    root.addEventListener('uk:portrait-progress-close', () => {
      const wasOpen = overlayOpen;
      overlayOpen = false;
      loading.hidden = true; progress.classList.remove('uk-optional-loading-modal');
      if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = ''; }
      if (composer.querySelector('.gemini-transformer__status--error') && !presentation.state().ready) {
        generating = false; queuedEmail = null;
        status($('[data-uk-email-status]'), 'Your portrait could not finish, so no email was sent. Please try creating it again.', true);
      }
      sync();
      if (!emailing && !queuedEmail) emailButton.textContent = 'Send my portrait + 10% off';
      if (wasOpen && presentation.state().ready) {
        const heading = root.querySelector('.uk-portrait__ready h1, .uk-portrait__ready h2, [data-uk-art]');
        heading?.setAttribute('tabindex', '-1'); heading?.focus({preventScroll:true});
        presentation.positionAtTop();
        requestAnimationFrame(() => { if (!overlayOpen && presentation.state().ready) presentation.positionAtTop(); });
      }
    });
    root.addEventListener('uk:portrait-ready', event => {
      if (generating && event.detail?.source === 'generated') generationArtwork = presentation.state().portrait;
    });
    root.addEventListener('uk:portrait-presented', () => {
      const state = presentation.state();
      if (!state.ready || state.demo || !validArtwork(state.portrait)) return;
      const queued = queuedEmail; queuedEmail = null; generating = false; sync();
      syncLoadingProgress();
      if (queued && queued.generation === generation && state.portrait === generationArtwork) void sendPortraitEmail(queued.recipient, state);
    });
    // Match the native modal's keyboard escape behavior and keep tab focus inside
    // the loading surface. Closing it never cancels generation.
    document.addEventListener('keydown', event => {
      if (!overlayOpen || event.key !== 'Tab') return;
      const controls = [...loading.querySelectorAll('button,summary,input')].filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !loading.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !loading.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    });
  }
  const token = new URLSearchParams(location.search).get('uk_preview');
  if (token && root.dataset.linkRestoreFailed !== 'true') {
    presentation.busy(true);
    api('restore?token=' + encodeURIComponent(token)).then(async data => {
      if (String(data.productId) !== root.dataset.productId || !validArtwork(data.artworkUrl)) throw new Error('This link does not match this portrait product.');
      if (!presentation.selectVariant(data.variantId, true)) throw new Error('The size or finish in this link is no longer available. Please contact us for help.');
      applyEmailFinish(data.variantId);
      // Only the verified new email flow suppresses the duplicate signup prompt.
      // Bind it to this artwork so another saved or amended portrait can be emailed.
      emailedGateArtwork = data.discountCode === 'YOURPORTRAIT10' && data.discountPercent === 10 ? data.artworkUrl : '';
      await commitArtwork({url:data.artworkUrl,id:data.portraitId}, 'emailed-entry');
      // A successful restore is only a visit after a visible, trusted interaction.
      // The separate email marker is absent from the immediate onsite unlock URL.
      try { armEmailVisit(token, data.artworkUrl); } catch { /* Tracking is optional. */ }
      // Retain the signed link: it works even when browser storage is blocked.
    }).catch(error => {
      emailedGateArtwork = '';
      const message = composer.querySelector('.gemini-transformer__status');
      if (message) { message.hidden = false; message.textContent = error.message; message.classList.add('gemini-transformer__status--error'); }
      root.dispatchEvent(new CustomEvent('uk:portrait-restore-error', {bubbles:true}));
      window.BellissimaPortraitEntry?.finish();
    }).finally(() => { presentation.busy(false); sync(); });
  }
  sync();
  return true;
  }
  if (!start()) {
    document.addEventListener('uk:portrait-ui-initialized', start, {once:true});
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  }
})();
